module.exports = __webpack_public_path__ + "img/zimowy_poranek_plus.599c8459.jpg";